import { render, staticRenderFns } from "./InvisibleOverlay.vue?vue&type=template&id=b7ece27c&lang=pug&"
import script from "./InvisibleOverlay.vue?vue&type=script&lang=ts&"
export * from "./InvisibleOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports